import { inject } from '@angular/core'
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router'
import { Store } from '@ngrx/store'
import { combineLatest, map, take, tap } from 'rxjs'
import { selectUserPermissions } from '../store/auth/auth.selectors'
import { eps } from '../services/url.service'
import { selectUserRoles } from '../store/user/user.selectors'

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router)
  const store = inject(Store)

  // Expected context passed in route data or elsewhere
  const contextBusinessId = route.data['businessId'] as string | undefined
  const contextOfficeId = route.data['officeId'] as string | undefined

  //   return combineLatest([
  //     store.select(selectUserPermissions), // as before: map entity -> permission array
  //     store.select(selectUserRoles) // new selector: provides user roles with businessId and officeId
  //   ]).pipe(
  //     take(1),
  //     map(([userPermissions, userRoles]) => {
  //       const permissionsData = route.data['permissions'] as
  //         | Record<string, string[]> // AND
  //         | Record<string, string[]>[] // OR
  //         | undefined

  //       // Filter userRoles based on context if context is provided
  //       //   const filteredRoles = userRoles?.filter(role => {
  //       //     if (contextBusinessId && role.businessId !== contextBusinessId) {
  //       //       return false
  //       //     }
  //       //     if (contextOfficeId && role.officeId !== contextOfficeId) {
  //       //       return false
  //       //     }
  //       //     return true
  //       //   })
  //       const filteredRoles = (userRoles ?? []).filter(role => {
  //         if (contextBusinessId && role.businessId !== contextBusinessId) {
  //           return false
  //         }
  //         if (contextOfficeId && role.officeId !== contextOfficeId) {
  //           return false
  //         }
  //         return true
  //       })

  //       // Aggregate permissions only from the filtered roles
  //       let filteredUserPermissions: Record<string, string[]> = {}

  //       for (const role of filteredRoles) {
  //         for (const [entity, actions] of Object.entries(role.permissions)) {
  //           if (!filteredUserPermissions[entity]) {
  //             filteredUserPermissions[entity] = []
  //           }
  //           // Merge unique actions
  //           actions.forEach(action => {
  //             if (!filteredUserPermissions[entity].includes(action)) {
  //               filteredUserPermissions[entity].push(action)
  //             }
  //           })
  //         }
  //       }

  //       const checkPermission = (entity: string, actions: string[]) =>
  //         actions.every(action => filteredUserPermissions[entity]?.includes(action))

  //       let hasPermission = false
  //       console.log('permission data, permission guard', permissionsData)
  //       if (Array.isArray(permissionsData)) {
  //         // OR logic → at least one set must match
  //         hasPermission = permissionsData.some(permissionSet =>
  //           Object.entries(permissionSet).every(([entity, actions]) =>
  //             checkPermission(entity, actions)
  //           )
  //         )
  //       } else if (permissionsData && typeof permissionsData === 'object') {
  //         // AND logic → all must match
  //         hasPermission = Object.entries(permissionsData).every(([entity, actions]) =>
  //           checkPermission(entity, actions)
  //         )
  //       } else {
  //         hasPermission = true // no permissions required
  //       }

  //       if (!hasPermission) {
  //         router.navigate([eps.user.unauthorizedPath])
  //       }

  //       return hasPermission
  //     })
  //   )

  //commented on 5 nov 2025
  // return store.select(selectUserPermissions).pipe(
  //   take(1),
  //   map(userPermissions => {
  //     const permissionsData = route.data['permissions'] as
  //       | Record<string, string[]>
  //       | Record<string, string[]>[]
  //       | undefined

  //     const checkPermission = (entity: string, actions: string[]) =>
  //       actions.every(action => userPermissions[entity]?.includes(action))

  //     let hasPermission = false
  //     if (Array.isArray(permissionsData)) {
  //       // OR logic → at least one set must match
  //       hasPermission = permissionsData.some(permissionSet =>
  //         Object.entries(permissionSet).every(([entity, actions]) =>
  //           checkPermission(entity, actions)
  //         )
  //       )
  //     } else if (permissionsData && typeof permissionsData === 'object') {
  //       const entities = Object.entries(permissionsData)

  //       if (entities.length > 1) {
  //         // OR logic → at least one entity must match
  //         hasPermission = entities.some(([entity, actions]) => checkPermission(entity, actions))
  //       } else {
  //         // Single object → AND logic (must match all actions)
  //         hasPermission = entities.every(([entity, actions]) => checkPermission(entity, actions))
  //       }
  //     } else {
  //       hasPermission = true // no permissions required
  //     }

  //     if (!hasPermission) {
  //       router.navigate([eps.user.unauthorizedPath])
  //     }

  //     return hasPermission
  //   })
  // )

  //5nov 2025
  return store.select(selectUserPermissions).pipe(
    take(1),
    map(userPermissions => {
      const permissionsData = route.data['permissions'] as
        | Record<string, string[]>
        | Record<string, string[]>[]
        | undefined

      // Helper: check if user has *all* required actions for an entity
      const hasActions = (entity: string, actions: string[]) =>
        actions.every(action => userPermissions[entity]?.includes(action))

      // Final permission flag
      let hasPermission = true

      if (Array.isArray(permissionsData)) {
        // Array = OR between sets; within each set = AND
        hasPermission = permissionsData.some(permissionSet =>
          Object.entries(permissionSet).every(([entity, actions]) => hasActions(entity, actions))
        )
      } else if (permissionsData && typeof permissionsData === 'object') {
        // Single object = AND between all entities/actions
        hasPermission = Object.entries(permissionsData).every(([entity, actions]) =>
          hasActions(entity, actions)
        )
      }

      return hasPermission
    }),
    tap(hasPermission => {
      if (!hasPermission) {
        router.navigate([eps.user.unauthorizedPath])
      }
    })
  )
}
